import "./icon.custom.caretDownCustom.css"
import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type IconCustomCaretDownCustomProps = ComponentProps<"svg">
function IconCustomCaretDownCustom(props: IconCustomCaretDownCustomProps) {
  const {
    className,
    viewBox = "0 0 24 24",
    fill = "none",
    width = 16,
    height = 16,
    ...svgProps
  } = props

  return (
    <svg
      className={cn("caret-down-custom", className)}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      aria-hidden
      {...svgProps}
    >
      <path className="caret-down-custom__path" d="M12 16L6 10H18L12 16Z" />
    </svg>
  )
}

export default IconCustomCaretDownCustom
